import { createContext, useContext } from 'react'

import { ReportType } from '../shared/types'

export const ReportTypeName: { [k: number]: string } = {
  [ReportType.Benchmark]: 'Benchmark Report',
  [ReportType.Workload]: 'System Check Report',
  // [ReportType.Infra]: 'Infra Report',
  [ReportType.Comparison]: 'Comparison Report',
  [ReportType.Health]: 'Health Report',
  [ReportType.OOM]: 'OOM Report',
  [ReportType.SlowLogVisual]: 'Slow Log Visualization',
  [ReportType.TrafficMirror]: 'Traffic Mirror Report'
}

// sync to the backend api prefix
export const ReportTypeAPIPrefix: { [k: number]: string } = {
  [ReportType.Benchmark]: 'health2',
  [ReportType.Workload]: 'workload',
  // [ReportType.Infra]: 'infra',
  [ReportType.SlowLogVisual]: 'slowlog-visual'
}

export const ReportTypeContext = createContext<ReportType>(null as any)

export const useReportTypeAPIPrefix = () => {
  const reportType = useContext(ReportTypeContext)
  return ReportTypeAPIPrefix[reportType]
}

export const useReportTypeName = () => {
  const reportType = useContext(ReportTypeContext)
  return ReportTypeName[reportType]
}
